import type { CalendarEvent } from '@centric-os/types';
import { useI18n } from 'vue-i18n';
import { Info } from 'luxon';

export default () => {
  const { t } = useI18n();

  const getEventAvailability = (menuEvent: CalendarEvent): string => {
    const dayOfWeek = menuEvent?.schedule?.dayOfWeek;
    if (!dayOfWeek)
      return t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.availableEveryDay');
    const weekdays = [1, 2, 3, 4, 5];
    if (weekdays.every((day) => dayOfWeek.includes(day))) {
      return t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.availableEveryWeekday');
    }
    const luxonDays = dayOfWeek.map((day) => (day === 0 ? 6 : day - 1)).toSorted((a, b) => a - b);

    const text = luxonDays
      .reduce((acc, val) => {
        acc += Info.weekdaysFormat('short')[val];
        acc += ', ';
        return acc;
      }, '')
      .slice(0, -2);
    return t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.customAvailability', {
      text,
    });
  };

  const getEventRotation = (menuEvent: CalendarEvent): string => {
    const repeat = menuEvent.schedule.every;
    if (!repeat || repeat.week === 1) {
      return t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.repeatEveryWeek');
    }
    const repeatEvery = Object.keys(repeat)[0];
    // @ts-expect-error FIXME: Element implicitly has an 'any' type because expression of type 'string' can'...
    const repeatEveryN = repeat[repeatEvery];
    const text = `${repeatEveryN} ${repeatEvery}s`;
    return t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.customRepeat', { text });
  };

  const isMenuEventVisible = (menuEvent: CalendarEvent): boolean => {
    return !menuEvent?.data?.is?.disabled;
  };

  const getOrderMethods = (pickup: boolean, delivery: boolean): string => {
    let orderMethods = `${t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.title')} `;
    if (pickup && delivery) {
      orderMethods += `${t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.pickup')}, ${t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.dropoff')}`;
    } else if (pickup) {
      orderMethods += t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.pickup');
    } else if (delivery) {
      orderMethods += t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.dropoff');
    } else {
      orderMethods += t('sites.schedule.sidePanel.menuSchedulePanel.eventCard.orderMethod.none');
    }
    return orderMethods;
  };

  return {
    getEventAvailability,
    getEventRotation,
    isMenuEventVisible,
    getOrderMethods,
  };
};
